import React from "react";
import EnquiriesInbox from "../../../../componrnt/pages/Enquiries/EnquiriesInbox";
import * as api from "../../../api/Enquiries";

// Branch scope. branch_id + user_id come from localStorage so the backend
// can scope all writes and enforce ownership.
const getBranchId = () => localStorage.getItem("b_id");
const getUserId = () => {
  try {
    return JSON.parse(localStorage.getItem("userData"))?.data?.id;
  } catch {
    return null;
  }
};

const branchApi = {
  listEnquiries: (params) =>
    api.enquiries({ branch_id: getBranchId(), ...params }),
  getEnquiry: (id) => api.enquiry(id, getBranchId()),
  reply: ({ message_id, body, attachment_url }) =>
    api.enquiry_reply({
      message_id, body, attachment_url,
      branch_id: getBranchId(),
      user_id: getUserId(),
    }),
  setStatus: (id, status) =>
    api.enquiry_status(id, { status, branch_id: getBranchId() }),
  createAnnouncement: ({ title, body, recipient_grade_id, attachment_url }) =>
    api.announcement_add({
      title, body, recipient_grade_id, attachment_url,
      branch_id: getBranchId(),
      user_id: getUserId(),
    }),
  uploadAttachment: (file) => api.upload_attachment(file),
};

const BranchEnquiries = () => <EnquiriesInbox api={branchApi} scope="branch" />;

export default BranchEnquiries;
